/* RESPONSIBLE TEAM: team-conversations */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default class ObjectsAttributeDescriptorSerializer extends EmbercomBaseSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    objectType: { key: 'object_type_id' },
    relationship: { embedded: 'always' },
    reference: { embedded: 'always' },
    listOptions: { embedded: 'always' },
    conditions: { embedded: 'always' },
  };
}
